import { render, staticRenderFns } from "./SinisterInfo.vue?vue&type=template&id=3dacee79"
import script from "./SinisterInfo.vue?vue&type=script&lang=js"
export * from "./SinisterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/ConceptsValidation/SinisterInfo.vue
// module id = 175
// module chunks = 31